// Generic recharts tooltip — shared across chart widgets that want the same
// dark card + coloured-dot-per-series look (see analytics/page.tsx and
// score/ScoreHistoryChart.tsx for the two existing inline copies this
// mirrors; new chart components should import this rather than adding a
// third copy).
export function ChartTooltip({
  active,
  payload,
  label,
}: {
  active?: boolean
  payload?: Array<{ name?: string; value: number; color?: string }>
  label?: string
}) {
  if (!active || !payload?.length) return null
  return (
    <div className="rounded-lg border border-border bg-surface px-3 py-2.5 text-xs shadow-lg">
      {label && <p className="mb-2 text-text-muted">{label}</p>}
      {payload.map((p, i) => (
        <div key={i} className="mb-1 flex items-center gap-2 last:mb-0">
          {p.color && <span className="h-2 w-2 shrink-0 rounded-full" style={{ backgroundColor: p.color }} />}
          <span className="text-text-muted">{p.name ?? 'Value'}:</span>
          <span className="font-bold tabular-nums text-text">{p.value}</span>
        </div>
      ))}
    </div>
  )
}
